import { createSelectorHook, useDispatch, type TypedUseSelectorHook } from 'react-redux';
import { combineReducers, configureStore } from '@reduxjs/toolkit';

import userReducer from './userSlice';
import tokenReducer from './authSlice';
import i18nReducer from './i18nSlice';
import configReducer from './configSlice';
import algoliaReducer from './algoliaSlice';

const RootReducer = combineReducers({
  auth: tokenReducer,
  user: userReducer,
  i18n: i18nReducer,
  config: configReducer,
  algolia: algoliaReducer,
});

export const setupStore = (preloadedState?: Partial<RootState>) =>
  configureStore({
    reducer: RootReducer,
    preloadedState,
  });

const store = setupStore();

export type RootState = ReturnType<typeof RootReducer>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = createSelectorHook();

export default store;
